// Usage tab: workspace-scoped spend. Captain canon 2026-04-26 — every
// tab inside a Workspace is diegetic to that Workspace; the org-wide
// rollup lives in account-level settings, not here.

import { Link } from "react-router-dom";
import { TabScrollbox } from "../../chrome/TabScrollbox";
import { UsageLimitsPanel } from "../../settings/UsageLimitsPanel";

interface Props {
  orgId: number | null;
  workspaceId: number;
}

export function UsageTab({ orgId, workspaceId }: Props) {
  if (orgId == null) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-3 px-8 text-center">
        <p className="max-w-md text-xs text-muted">
          No org is resolved for this workspace yet. Open Settings directly
          to manage usage caps and provider keys.
        </p>
        <Link
          to="/settings"
          className="rounded-md border border-edge bg-surface-raised px-3 py-1.5 text-xs font-medium text-primary transition-colors hover:border-accent"
        >
          Open Settings
        </Link>
      </div>
    );
  }

  return (
    <TabScrollbox>
      <div className="flex w-full flex-col gap-6">
        <header>
          <p className="max-w-2xl text-xs text-muted">
            Spend for this workspace — model tokens, sandbox compute, and
            integration calls. Waytide bills nothing for BYOK providers.
          </p>
        </header>

        <UsageLimitsPanel
          orgId={orgId}
          workspaceId={workspaceId}
          scopeLabel="this workspace"
        />
      </div>
    </TabScrollbox>
  );
}
